import React, { Suspense } from 'react';
import { Switch, RouteComponentProps, Redirect } from 'react-router-dom';
import CurrentCustomerCreationProvider from 'context/global-customer-creation';
import RouteWithSubRoutes from 'components/shared/RouteWithSubRoutes';
import LoadingSpinner from 'components/shared/LoadingSpinner';
import useBreadcrumbs from 'hooks/useBreadcrumbs';

import OnboardingSaveStepsProvider from 'context/onboarding-save-steps';
import PLDSaveStepsProvider from 'context/pld-save-steps';
import OnboardingSaveStepsMoralPersonProvider from 'context/onboarding-moral-person-save-steps';
import ProfilingSaveStepsProvider from 'context/profiling-save-steps';
import DocumentSaveStepsProvider from 'context/document-save-steps';
import CustomerProvider from 'context/customer-data';
import ClientsManagementProvider from 'context/clients-management';
import CoOwnersManagementProvider from 'context/co-owners-management';

import routes from './routes';

const ClientsContainer = ({ history }: RouteComponentProps) => {
  useBreadcrumbs(history, routes);

  return (
    <Suspense fallback={<LoadingSpinner />}>
      <CurrentCustomerCreationProvider>
        <OnboardingSaveStepsProvider>
          <OnboardingSaveStepsMoralPersonProvider>
            <CoOwnersManagementProvider>
              <PLDSaveStepsProvider>
                <ProfilingSaveStepsProvider>
                  <DocumentSaveStepsProvider>
                    <CustomerProvider sourceType="clientes">
                      <ClientsManagementProvider>
                        <Switch>
                          {routes.map((route, i) => {
                            return (
                              <RouteWithSubRoutes
                                key={`${i}_${route.path}`}
                                {...route}
                              />
                            );
                          })}
                          <Redirect to={'/'} />
                        </Switch>
                      </ClientsManagementProvider>
                    </CustomerProvider>
                  </DocumentSaveStepsProvider>
                </ProfilingSaveStepsProvider>
              </PLDSaveStepsProvider>
            </CoOwnersManagementProvider>
          </OnboardingSaveStepsMoralPersonProvider>
        </OnboardingSaveStepsProvider>
      </CurrentCustomerCreationProvider>
    </Suspense>
  );
};

export default ClientsContainer;
